module.exports = __webpack_public_path__ + "img/VSCode-icon.f33229c6.svg";